(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-image-normalizer"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = 'product-card img.product-media__image';
    const pending = new Set();
    let scheduled = false;

    const clamp = (minimum, value, maximum) => Math.min(maximum, Math.max(minimum, value));
    const analysisImages = new Map();

    const loadAnalysisImage = (source) => {
      if (analysisImages.has(source)) return analysisImages.get(source);

      const promise = new Promise((resolve, reject) => {
        const image = document.createElement('img');
        image.crossOrigin = 'anonymous';
        image.decoding = 'async';
        image.addEventListener('load', () => resolve(image), { once: true });
        image.addEventListener('error', reject, { once: true });
        image.src = source;
      });

      analysisImages.set(source, promise);
      return promise;
    };

    const median = (values) => {
      if (values.length === 0) return 255;
      values.sort((a, b) => a - b);
      return values[Math.floor(values.length / 2)];
    };

    const findBounds = (image) => {
      const maximumSide = 180;
      const imageRatio = image.naturalWidth / image.naturalHeight;
      const canvasWidth = imageRatio >= 1 ? maximumSide : Math.max(1, Math.round(maximumSide * imageRatio));
      const canvasHeight = imageRatio >= 1 ? Math.max(1, Math.round(maximumSide / imageRatio)) : maximumSide;
      const canvas = document.createElement('canvas');
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return null;

      context.drawImage(image, 0, 0, canvasWidth, canvasHeight);
      const pixels = context.getImageData(0, 0, canvasWidth, canvasHeight).data;
      const edgeRed = [];
      const edgeGreen = [];
      const edgeBlue = [];
      let transparentEdges = 0;
      let edgeCount = 0;

      const recordEdge = (x, y) => {
        const offset = (y * canvasWidth + x) * 4;
        const alpha = pixels[offset + 3];
        edgeCount += 1;
        if (alpha < 20) {
          transparentEdges += 1;
          return;
        }
        edgeRed.push(pixels[offset]);
        edgeGreen.push(pixels[offset + 1]);
        edgeBlue.push(pixels[offset + 2]);
      };

      for (let x = 0; x < canvasWidth; x += 1) {
        recordEdge(x, 0);
        recordEdge(x, canvasHeight - 1);
      }

      for (let y = 1; y < canvasHeight - 1; y += 1) {
        recordEdge(0, y);
        recordEdge(canvasWidth - 1, y);
      }

      const transparentBackground = transparentEdges / Math.max(1, edgeCount) > 0.55;
      const backgroundRed = median(edgeRed);
      const backgroundGreen = median(edgeGreen);
      const backgroundBlue = median(edgeBlue);
      const columnCounts = new Uint16Array(canvasWidth);
      const rowCounts = new Uint16Array(canvasHeight);
      let foregroundPixels = 0;

      for (let y = 0; y < canvasHeight; y += 1) {
        for (let x = 0; x < canvasWidth; x += 1) {
          const offset = (y * canvasWidth + x) * 4;
          const alpha = pixels[offset + 3];
          if (alpha < 20) continue;

          const redDelta = pixels[offset] - backgroundRed;
          const greenDelta = pixels[offset + 1] - backgroundGreen;
          const blueDelta = pixels[offset + 2] - backgroundBlue;
          const colorDistance = Math.sqrt(redDelta * redDelta + greenDelta * greenDelta + blueDelta * blueDelta);
          const isForeground = transparentBackground || colorDistance > 34;

          if (isForeground) {
            columnCounts[x] += 1;
            rowCounts[y] += 1;
            foregroundPixels += 1;
          }
        }
      }

      if (foregroundPixels < canvasWidth * canvasHeight * 0.004) return null;

      const minimumColumnPixels = Math.max(1, Math.round(canvasHeight * 0.006));
      const minimumRowPixels = Math.max(1, Math.round(canvasWidth * 0.006));
      let left = 0;
      let right = canvasWidth - 1;
      let top = 0;
      let bottom = canvasHeight - 1;

      while (left < right && columnCounts[left] < minimumColumnPixels) left += 1;
      while (right > left && columnCounts[right] < minimumColumnPixels) right -= 1;
      while (top < bottom && rowCounts[top] < minimumRowPixels) top += 1;
      while (bottom > top && rowCounts[bottom] < minimumRowPixels) bottom -= 1;

      const horizontalPadding = Math.max(1, Math.round(canvasWidth * 0.015));
      const verticalPadding = Math.max(1, Math.round(canvasHeight * 0.015));

      left = Math.max(0, left - horizontalPadding);
      right = Math.min(canvasWidth - 1, right + horizontalPadding);
      top = Math.max(0, top - verticalPadding);
      bottom = Math.min(canvasHeight - 1, bottom + verticalPadding);

      return {
        left: left / canvasWidth,
        right: (right + 1) / canvasWidth,
        top: top / canvasHeight,
        bottom: (bottom + 1) / canvasHeight
      };
    };

    const normalize = async (image) => {
      const source = image.currentSrc || image.src;
      if (!source || image.dataset.productImageNormalizedSource === source) return;
      if (!image.complete || image.naturalWidth === 0 || image.naturalHeight === 0) {
        image.addEventListener('load', () => queueImage(image), { once: true });
        return;
      }

      try {
        const analysisImage = await loadAnalysisImage(source);
        const bounds = findBounds(analysisImage);
        if (!bounds) {
          image.dataset.productImageNormalizedSource = source;
          return;
        }

        const media = image.closest('.product-media');
        const elementWidth = image.clientWidth || media?.clientWidth || image.naturalWidth;
        const elementHeight = image.clientHeight || media?.clientHeight || image.naturalHeight;
        const intrinsicRatio = image.naturalWidth / image.naturalHeight;
        const elementRatio = elementWidth / elementHeight;
        let displayedWidth;
        let displayedHeight;

        if (intrinsicRatio >= elementRatio) {
          displayedWidth = elementWidth;
          displayedHeight = elementWidth / intrinsicRatio;
        } else {
          displayedHeight = elementHeight;
          displayedWidth = elementHeight * intrinsicRatio;
        }

        const offsetX = (elementWidth - displayedWidth) / 2;
        const offsetY = (elementHeight - displayedHeight) / 2;
        const boundsWidth = (bounds.right - bounds.left) * displayedWidth;
        const boundsHeight = (bounds.bottom - bounds.top) * displayedHeight;
        const centerX = offsetX + ((bounds.left + bounds.right) / 2) * displayedWidth;
        const centerY = offsetY + ((bounds.top + bounds.bottom) / 2) * displayedHeight;
        const coverage = Math.max(boundsWidth / elementWidth, boundsHeight / elementHeight);
        const scale = clamp(0.78, 0.78 / Math.max(coverage, 0.01), 1.5);
        const shiftX = (0.5 - centerX / elementWidth) * scale * 100;
        const shiftY = (0.5 - centerY / elementHeight) * scale * 100;

        image.style.setProperty('--product-image-normalized-scale', scale.toFixed(3));
        image.style.setProperty('--product-image-shift-x', shiftX.toFixed(2) + '%');
        image.style.setProperty('--product-image-shift-y', shiftY.toFixed(2) + '%');
        image.dataset.productImageNormalizedSource = source;
      } catch (error) {
        image.dataset.productImageNormalizedSource = source;
      }
    };

    const runQueue = async () => {
      scheduled = false;
      const batch = Array.from(pending).slice(0, 6);
      batch.forEach((image) => pending.delete(image));
      await Promise.all(batch.map(normalize));
      if (pending.size > 0) scheduleQueue();
    };

    const scheduleQueue = () => {
      if (scheduled) return;
      scheduled = true;
      const run = () => runQueue();
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 180 });
      } else {
        window.setTimeout(run, 16);
      }
    };

    const queueImage = (image) => {
      if (!(image instanceof HTMLImageElement) || !image.matches(selector)) return;
      pending.add(image);
      scheduleQueue();
    };

    const scan = (root) => {
      if (root instanceof HTMLImageElement) queueImage(root);
      if (root instanceof Element || root instanceof Document) {
        root.querySelectorAll(selector).forEach(queueImage);
      }
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.target instanceof HTMLImageElement) {
          mutation.target.removeAttribute('data-product-image-normalized-source');
          queueImage(mutation.target);
          return;
        }
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) scan(node);
        });
      });
    });

    const start = () => {
      scan(document);
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'srcset']
      });
      document.addEventListener('shopify:section:load', (event) => scan(event.target));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search"] && !Shopify.designMode) return;
  try {
    const animatedSearchTerms = document.querySelectorAll('[data-search-animated-term]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  animatedSearchTerms.forEach((element) => {
    if (element.dataset.animationReady === 'true') return;

    const terms = element.dataset.searchTerms.split('|').filter(Boolean);
    element.dataset.animationReady = 'true';

    if (prefersReducedMotion || terms.length < 2) {
      element.textContent = terms[0] || '';
      return;
    }

    let termIndex = 0;
    let characterIndex = terms[0].length;
    let deleting = true;

    const animate = () => {
      const currentTerm = terms[termIndex];

      if (deleting) {
        characterIndex -= 1;
        element.textContent = currentTerm.slice(0, Math.max(characterIndex, 0));

        if (characterIndex <= 0) {
          deleting = false;
          termIndex = (termIndex + 1) % terms.length;
          window.setTimeout(animate, 350);
          return;
        }

        window.setTimeout(animate, 55);
        return;
      }

      characterIndex += 1;
      element.textContent = terms[termIndex].slice(0, characterIndex);

      if (characterIndex >= terms[termIndex].length) {
        deleting = true;
        window.setTimeout(animate, 1500);
        return;
      }

      window.setTimeout(animate, 85);
    };

    window.setTimeout(animate, 1500);
  });
  } catch(e) { console.error(e); }
})();

})();
